export const AUTH_TOKEN = 'authToken';
export const GOOGLE_TOKEN = 'googleToken';
export const APPLE_CODE = 'appleCode';
export const SIGN_UP_FLOW = 'signUpFlow';
export const CAMPAIGN = 'campaign';
export const INTERNAL_ANALYTICS = 'iac';
export const SHOWN_PROFILE_PROGRESS = 'shProProgress';
export const SIGN_UP_INFO = 'signUpAccount';
export const BIRTHDAY_MONTH = 'month';
export const BIRTHDAY_DAY = 'day';
export const BIRTHDAY_YEAR = 'year';
export const COOKIE_CONSENT = 'cookie_consent_v1';
